import { Link } from 'react-router-dom';

const projects = [
  {
    src: 'https://public.readdy.ai/ai/img_res/5aa754c2b9291afa7c74a9ba60695af5.jpg',
    label: 'Premium Fence Installation',
    city: 'Ormond Beach, FL',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=luxury%20residential%20landscape%20installation%20Florida%20tropical%20plants%20lush%20emerald%20lawn%20premium%20planting%20beds%20vibrant%20colors%20professional%20craftsmanship%20elegant%20upscale%20garden&width=600&height=500&seq=dippels-proj-2&orientation=landscape',
    label: 'Full Landscape Installation',
    city: 'Palm Coast, FL',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=stunning%20outdoor%20landscape%20lighting%20at%20night%20luxury%20Florida%20home%20warm%20amber%20pathway%20lights%20dramatic%20uplighting%20trees%20elegant%20garden%20nighttime%20scene&width=600&height=500&seq=dippels-proj-3&orientation=landscape',
    label: 'Architectural Lighting Design',
    city: 'Daytona Beach, FL',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=luxury%20natural%20stone%20paver%20patio%20outdoor%20living%20area%20Florida%20home%20elegant%20pool%20deck%20premium%20craftsmanship%20sophisticated%20design%20upscale%20backyard&width=600&height=500&seq=dippels-proj-4&orientation=landscape',
    label: 'Custom Paver Patio',
    city: 'Port Orange, FL',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=premium%20Florida%20residential%20landscaping%20sod%20installation%20manicured%20lawn%20lush%20tropical%20planting%20beds%20elegant%20mulch%20borders%20professional%20quality%20vibrant%20green&width=600&height=500&seq=dippels-proj-5&orientation=landscape',
    label: 'Sod & Landscape Installation',
    city: 'New Smyrna Beach, FL',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=premium%20outdoor%20transformation%20luxury%20Florida%20backyard%20complete%20landscape%20makeover%20high-end%20paver%20patio%20landscape%20lighting%20fence%20elegant%20evening%20golden%20light&width=600&height=500&seq=dippels-proj-6&orientation=landscape',
    label: 'Complete Outdoor Transformation',
    city: 'Edgewater, FL',
  },
];

export default function ProjectShowcase() {
  return (
    <section className="bg-white py-28 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="text-gold font-sans text-[11px] font-semibold tracking-[0.28em] uppercase mb-4 flex items-center gap-3">
              <span className="h-px w-8 bg-gold inline-block"></span>
              Our Work
            </p>
            <h2 className="font-serif text-charcoal font-bold leading-tight" style={{ fontSize: 'clamp(32px, 3.2vw, 48px)' }}>
              Projects That Speak<br />for Themselves
            </h2>
          </div>
          <Link
            to="/services"
            className="inline-flex items-center gap-2 border border-charcoal/20 text-charcoal text-sm font-semibold px-7 py-3.5 rounded-full hover:bg-charcoal hover:text-white transition-all whitespace-nowrap self-start md:self-auto"
          >
            View All Services <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Masonry-style grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          {projects.map((p, i) => (
            <div
              key={i}
              className={`group relative overflow-hidden rounded-xl cursor-pointer ${
                i === 0 || i === 3 ? 'row-span-1 h-72' : 'h-56'
              }`}
            >
              <img
                src={p.src}
                alt={`${p.label} — Dippel's Outdoor Services ${p.city}`}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-[1.06] transition-transform duration-700 ease-out"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400"></div>

              {/* Content on hover */}
              <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-400">
                <p className="text-white font-serif font-semibold text-base leading-tight mb-0.5">{p.label}</p>
                <p className="text-white/65 text-xs flex items-center gap-1">
                  <i className="ri-map-pin-line text-gold text-xs"></i>
                  {p.city}
                </p>
              </div>

              {/* Corner accent */}
              <div className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-zoom-in-line text-white text-xs"></i>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="text-center mt-10">
          <p className="text-charcoal-muted text-sm">
            Every project is completed with{' '}
            <strong className="text-charcoal">meticulous craftsmanship</strong> and backed by our{' '}
            <strong className="text-charcoal">100% satisfaction guarantee</strong>.
          </p>
        </div>
      </div>
    </section>
  );
}
